import { render, staticRenderFns } from "./PeriodeView.vue?vue&type=template&id=8b878620&"
import script from "./PeriodeView.js?vue&type=script&lang=js&"
export * from "./PeriodeView.js?vue&type=script&lang=js&"
import style0 from "./PeriodeView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports